export const KARYON_REPO = 'https://github.com/karyontech/karyon'
export const KARYON_BRANCH = 'master'
export const KARYON_TREE = `${KARYON_REPO}/tree/${KARYON_BRANCH}`
export const karyonSrc = (path) => `${KARYON_TREE}/${path}`
